module.exports = __webpack_public_path__ + "static/esco-11-3675a7c8d993a7d53731037bdfa5036e.jpeg";